/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { IntlProvider } from 'react-intl';
import { JssProvider } from 'react-jss';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import App from 'src/shared/app/base/component/App';
import { isDevModeEnabled } from 'src/shared/app/base/selector/appEnvSelectors';
import { getLocale } from 'src/shared/app/locale/selector/localeSelectors';

import type { Store } from 'src/shared/core/type/reduxTypes';

type Props = {
  store: Store,
  messages?: Object,
};

const ClientApp = ({ store, messages }: Props): React.Node => {
  const state = store.getState();

  return (
    <Provider store={store}>
      <IntlProvider locale={getLocale(state)} messages={messages}>
        <BrowserRouter>
          <JssProvider id={{ minify: !isDevModeEnabled(state) }}>
            <App />
          </JssProvider>
        </BrowserRouter>
      </IntlProvider>
    </Provider>
  );
};

export default compose(React.memo)(ClientApp);
